import React from "react";
import { Box, Typography } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";

const TopBar = () => {
  return (
    <Box sx={{ background: "#065f46", color: "#fff" }}>
      <Box
        sx={{
          maxWidth: "1200px",
          mx: "auto",
          px: 2,
          py: 1,
          display: "flex",
          flexDirection: { xs: "column", md: "row" }, // 🔑 STACK ON MOBILE
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", md: "center" },
          gap: { xs: 0.8, md: 0 }
        }}
      >
        {/* LEFT SIDE */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "row", sm: "row" },
            gap: { xs: 0.5, sm: 3 }
            
          }}
        >
          {/* PHONE */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <PhoneIcon sx={{ fontSize: 18, color: "#a7f3d0" }} />
            <Typography sx={{ fontSize: 14, fontWeight: 500, color: "#fff" }}>
              +91 6230206562
            </Typography>
          </Box>

          {/* EMAIL */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <EmailIcon sx={{ fontSize: 18, color: "#a7f3d0" }} />
            <Typography sx={{ fontSize: 14, fontWeight: 500, color: "#fff" }}>
              info@ajaysharmahimachal.com
            </Typography>
          </Box>
        </Box>

        {/* RIGHT SIDE (DESKTOP ONLY) */}
        <Typography
          sx={{
            display: { xs: "none", md: "block" },
            fontSize: 14,
            fontWeight: 500,
            color: "#ecfdf5",
            letterSpacing: "0.3px"
          }}
        >
          Explore Himalayas Like Never Before
        </Typography>
      </Box>
    </Box>
  );
};

export default TopBar;
